import React from "react";
import LegalShell from "@/components/LegalShell";

export default function Retractation() {
  return (
    <LegalShell title="Droit de rétractation" lastUpdated="6 février 2026" testId="page-retract">
      <p>Conformément à la directive européenne 2011/83/UE et aux articles L.221-18 à L.221-28 du Code de la consommation, l'utilisateur consommateur dispose d'un droit de rétractation de <strong>14 jours calendaires</strong> à compter de la souscription du Service Premium.</p>

      <h2>Exception légale — contenu numérique</h2>
      <p>Le Service Premium fournit l'accès immédiat à des fonctionnalités numériques (modèles téléchargeables, accès anticipé aux bons plans). En souscrivant et en utilisant le Service avant la fin du délai de rétractation, l'utilisateur <strong>renonce expressément à son droit de rétractation</strong> conformément à l'article L.221-28 13° du Code de la consommation.</p>

      <h2>Si tu n'as pas utilisé le Service</h2>
      <p>Si tu n'as pas téléchargé de modèle ni utilisé une fonctionnalité Premium pendant les 14 jours suivant ta souscription, tu peux exercer ton droit de rétractation en envoyant un email à <strong>contact.servicedecomdu64@gmail.com</strong> avec :</p>
      <ul>
        <li>Ton nom complet et email du compte ;</li>
        <li>La date de souscription ;</li>
        <li>L'objet : « Rétractation abonnement Premium ».</li>
      </ul>
      <p>Le remboursement intégral sera effectué sous <strong>14 jours</strong> après réception de la demande, par le même moyen de paiement.</p>

      <h2>Formulaire-type de rétractation</h2>
      <pre className="bg-slate-100 p-4 rounded-lg text-sm whitespace-pre-wrap">
À l'attention de Jamira LHASSANI — contact.servicedecomdu64@gmail.com :

Je vous notifie par la présente ma rétractation
du contrat de souscription au Service Premium
Student Hub conclu le [date].

Nom : [Prénom Nom]
Email du compte : [email]
Date : [date du jour]
Signature (si lettre papier) :
      </pre>

      <h2>Information précontractuelle</h2>
      <p>En procédant à la souscription, l'utilisateur reconnaît avoir été informé : (i) du prix TTC, (ii) du caractère immédiat de la fourniture, (iii) de la perte du droit de rétractation en cas d'usage immédiat du Service.</p>
    </LegalShell>
  );
}
